import apiClient from '../../../apis/portaliref';
import { portaleApi } from '../../../helpers/portaleModuleHelper';

const api = portaleApi('servizioTop', apiClient, {
    // const api = portaleApi('photoGalleries', apiClient, {
    // top: 'perPage',
    per_page: 'perPage',
    page: 'page',
    nome: 'q',
    anagrafica: 'ao_hotel_id'
});

api.serviziTop = (id, data) => {
    return apiClient({
        url: `servizioTop/${id}`,
        method: 'patch',
        data,
    });
};

api.fetchServizi = (idHotel) => {
    return apiClient({
        url: `anagrafica/servizi/${idHotel}`,
        method: 'get',
    });
};

export default api;
